const es = {
  "menu.staff_meal": "Control de Alimentación",
};

export default es;
